import React from 'react'
import { ContentStackPalette } from '../interfaces/ContentStackPalette'
import styled from 'styled-components'
import section from './Section'

interface ReviewsCarouselData {
  data: {
    title: string | null,
    _metadata: {
      uid: string
    },
    'text_color': ContentStackPalette[] | null,
    'font_size': number | null,
    'alignment': string,
    'background_color': ContentStackPalette[] | null,
    'mode': string,
    'type': string,
    'reviews_count': number,
    'show_bottomline': boolean,
    'autoplay': boolean,
    'autoplay_speed': number,
    'show_navigation': boolean
  }
}

const ReviewsCarousel = ({ data }: ReviewsCarouselData): JSX.Element => {
  const {
    mode,
    type,
    reviews_count,
    show_bottomline,
    autoplay,
    autoplay_speed,
    show_navigation
  } = data
  return (
    <Container className='yotpo yotpo-reviews-carousel'
       data-mode={mode}
       data-type={type}
       data-count={reviews_count}
       data-show-bottomline={show_bottomline}
       data-autoplay-enabled={autoplay}
       data-autoplay-speed={autoplay_speed}
       data-show-navigation={show_navigation}>&nbsp;
    </Container>
  )
}

export default ReviewsCarousel

const Container = styled.div`
  width: 1120px;
  margin: 0 auto !important;
  overflow: hidden;
`;